export const SET_USER_HASH = "SET_USER_HASH";
export const USER_HASH_EXPIRED = "USER_HASH_EXPIRED";
export const SET_FEEDBACK_DETAILS = "SET_FEEDBACK_DETAILS";
export const FETCH_USER_OBJECT = "FETCH_USER_OBJECT";
export const FETCH_USER_IDENTITY_DATA_FAILED = "FETCH_USER_IDENTITY_DATA_FAILED";
export const FETCH_USER_IDENTITY_DATA = "FETCH_USER_IDENTITY_DATA";
export const FETCH_USER_TYPE_DETAILS = 'FETCH_USER_TYPE_DETAILS';
export const SET_USER_TYPE_DETAILS = 'SET_USER_TYPE_DETAILS';

export function setUserHash(payload) {
    return {
        type: SET_USER_HASH,
        payload: payload
    }
}

export function setFeedbackDetails(payload) {
    return {
        type: SET_FEEDBACK_DETAILS,
        payload: payload
    }
}

export function setUserTypeDetails(payload){
    return{
        type: SET_USER_TYPE_DETAILS,
        payload
    }
}